import { createFileRoute } from "@tanstack/react-router";

import { useAuth } from "@/contexts/AuthProvider";

export const Route = createFileRoute("/_authenticated/")({
  component: DashboardPage,
});

function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Dashboard</h2>
        <p className="text-muted-foreground text-sm">
          Welcome{user?.name ? `, ${user.name}` : ""}.
        </p>
      </div>
      <div className="bg-card text-card-foreground rounded-lg border p-4">
        <p className="text-muted-foreground text-sm">
          Northstar is GCDE&apos;s Search benchmarking and validation platform.
          Use Compare for ephemeral 4-way Kingpin product-search compares
          (version-only). Agents run the same compare via POST /compare/v1.
        </p>
      </div>
    </div>
  );
}
